<template>
    <div>
        <form :id="'tukang_staff_form_' + stylistID" @submit.prevent="submitFormData">
            <div class="row">
                <div class="col-sm-12 col-md-6 border-right p-3">
                    <!-- <div v-if="!isEdit" class="form-group">
                        <label class="form-label">{{$t('label.name')}}</label>
                        <div class="input-group">
                            <div class="input-group-prepend w-100">
                                <label class="input-group-text border-right-0 bg-transparent">
                                    <i class="fas fa-user"></i>
                                </label>
                                <multiselect  
                                    v-model="selectedStaff" 
                                    :options="staffs" 
                                    group-values="staff" group-label="outlet" 
                                    track-by="staffID" label="name" 
                                    :show-labels="false" 
                                    openDirection="below" 
                                    @select="selectStaff">
                                    <span slot="noResult">{{$t('table.no_records')}}</span>
                                </multiselect>
                            </div>
                        </div>
                    </div> -->
                    <div class="form-group">
                        <label class="form-label">{{$t('label.name')}}</label>
                        <div class="input-group bg-white shadow-inset-2">
                            <div class="input-group-prepend">
                                <span class="input-group-text bg-transparent border-right-0">
                                    <i class="fas fa-user"></i>
                                </span>
                            </div>
                            <input type="text" class="form-control bg-transparent pl-3" :placeholder="$t('label.name')" v-model="stylistName">
                            <input type="hidden"  v-model="stylistID">
                        </div>
                    </div>
                    <div class="form-group">
                        <label class="form-label">{{$t('label.location')}}</label>
                        <div class="input-group bg-white shadow-inset-2">
                            <div class="input-group-prepend">
                                <span class="input-group-text bg-transparent border-right-0">
                                    <i class="fas fa-map-marker-alt"></i>
                                </span>
                            </div>
                            <input type="text" class="form-control bg-transparent pl-3" :placeholder="$t('label.location')" v-model="location">
                        </div>
                    </div>
                    <div class="form-group">
                        <label class="form-label">{{$t('label.city')}}</label>
                        <div class="input-group">
                            <div class="input-group-prepend w-100">
                                <label class="input-group-text border-right-0 bg-transparent">
                                    <i class="fas fa-map-marker-alt"></i>
                                </label>
                                <multiselect  
                                    v-model="selectedCity" 
                                    :options="cities" 
                                    group-values="city" group-label="state" 
                                    track-by="cityID" label="city" 
                                    :show-labels="false" 
                                    openDirection="below" 
                                    @select="selectCity">
                                    <span slot="noResult">{{$t('table.no_records')}}</span>
                                </multiselect>
                            </div>
                        </div>
                    </div>
                    <div class="form-group">
                        <label class="form-label">{{$t('label.details')}}</label>
                        <textarea class="form-control" :placeholder="$t('label.details')" rows="5" v-model="stylistDetails"></textarea>
                    </div>
                    <div class="form-group mb-1">
                        <label class="form-label">{{$t('label.contact')}}</label>
                        <div class="input-group bg-white shadow-inset-2">
                            <div class="input-group-prepend">
                                <span class="input-group-text bg-transparent border-right-0">
                                    <i class="fas fa-phone-alt"></i>
                                </span>
                            </div>
                            <input type="text" class="form-control bg-transparent pl-3" :placeholder="$t('label.contact')" v-model="contact" @keyup="contactValidation">
                        </div>
                        <div id="errStaff" class="error-validation"></div>
                    </div>
                    <div class="help-block fs-xs">
                        <p class="mb-0">{{$t('message.contact_validation.notes')}}:</p>
                        <ul>
                            <li>{{$t('message.contact_validation.my')}} 601x xxx xxxx</li>
                            <li>{{$t('message.contact_validation.sg')}} 65x xxx xxxx</li>
                        </ul>
                    </div>
                </div>
                <div class="col-sm-12 col-md-6 p-5">
                    <h6 class="text-dark fw-500">{{$t('subMenu.salon_setting_staff')}} {{$t('label.image')}}:</h6>
                    <div class="card-columns">
                        <div v-for="item in gallery" :key="item.id " class="card">
                            <div v-if="item.src != ''">
                                <div class="card-header p-2 border-bottom-0 d-flex align-items-center justify-content-end">
                                    <div class="text-primary">
                                        <a class="link mr-2" @click="showUploadImage(item)">
                                            <i class="fal fa-cog"></i>
                                        </a>
                                        <a class="link" @click="showDeleteImage(item)">
                                            <i class="fal fa-trash"></i>
                                        </a>
                                    </div>
                                </div>
                                <img class="border-top-left-radius-0 border-top-right-radius-0 card-img-top" :src="getImage(item.src)"/>
                            </div>
                            <div v-else>
                                <div class="card-header p-2 border-bottom-0 d-flex align-items-center justify-content-end" style="height: 2.5em;"></div>
                                <div class="pt-5 pb-5 card-body d-flex align-items-center justify-content-center">
                                    <a class="link" title="Add Image" @click="showUploadImage(item)">
                                        <div class='icon-stack display-3'>
                                            <i class="fas fa-image-polaroid icon-stack-3x opacity-50 color-fusion-500" ></i>
                                            <i class="fas fa-plus-circle icon-stack-1x opacity-100 color-fusion-300"></i>
                                        </div>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row border-top pt-3 mt-3 mb-3">
                <div class="col-6 text-left">
                    <button type="button" class="btn border-0 btn-secondary btn-padding waves-effect waves-themed mr-3" @click="returnStaffList">{{$t('button_link.cancel')}}</button>
                    <button type="submit" class="btn border-0 btn-primary btn-padding waves-effect waves-themed">{{$t('button_link.save')}}</button>
                </div>
                <div class="col-6 text-right">
                    <button v-if="isEdit" type="button" class="btn border-0 btn-danger btn-padding waves-effect waves-themed" @click="showDeleteStylist">{{$t('button_link.disable', {'item': $t('tukang.stylist')})}}</button>
                </div>
            </div>
        </form>
        <div :class="{'show': uploadToggle }" class="modal fade">
            <div class="modal-dialog modal-lg modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header border-bottom">
                        <h5 class="modal-title h4 d-flex align-items-center"><i class="fas fa-cloud-upload-alt mr-3"></i>{{$t('header.upload_image')}}</h5>
                        <button type="button" class="close" @click="uploadToggle = false">
                            <span aria-hidden="true"><i class="fal fa-times"></i></span>
                        </button>
                    </div>
                    <div class="modal-body pt-3">
                        <div class="border-bottom pb-1 mb-3" v-if="selectedImage.src != ''">
                            <h6 class="fw-500">{{$t('label.selected_image')}}: </h6>
                            <img class="img-thumbnail mb-3" :src="getImage(selectedImage.src)"/>
                        </div>
                        <div :class="!isDropzoneShow ? 'float-right' : 'text-right mb-2'">
                            <button class="btn btn-outline-primary" type="button" :title="isDropzoneShow ? $t('label.select_existing_image') : $t('button_link.cancel')"  @click="isDropzoneShow = !isDropzoneShow">
                                <span class="fal mr-2" :class="isDropzoneShow ? 'fa-image' : 'fa-window-close'"></span>
                                <span>{{isDropzoneShow ? $t('label.select_existing_image') : $t('button_link.cancel')}}</span>
                            </button>
                        </div>
                        <div v-show="!isDropzoneShow">
                            <h6 class="mt-5 mb-3 text-dark fw-500">{{$t('subMenu.salon_setting_staff')}} {{$t('label.image')}}:</h6>
                            <div class="panel-tag mt-3" v-if="staffGallery.length == 0">
                                {{$t('table.no_records')}}
                            </div>
                            <div class="row mt-3">
                                <div class="col">
                                    <div class="demo">
                                        <div v-for="o in staffGallery" :key="o.imageID" class="btn btn-lg btn-outline-default bg-transparent text-left">
                                            <div class="custom-control custom-checkbox mb-1" style="margin-left: -1em;">
                                                <input name="galleryCbx" type="checkbox" class="custom-control-input" :id="'cbx_staff_image_' + o.imageID" :value="o.imageID" @click="selectThisImage($event)">
                                                <label class="custom-control-label" :for="'cbx_staff_image_' + o.imageID"></label>
                                            </div>
                                            <img class="img-item" :src="o.path"/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="staffGallery.length != 0" class="border-top text-left pt-3 mt-3 mb-3">
                                <button type="button" class="btn border-0 btn-primary btn-padding" @click="addExistingImage">{{$t('button_link.add')}}</button>
                            </div>
                        </div>
                        <vue-dropzone v-show="isDropzoneShow" :id="selectedImage.id" ref="dropzone" class="text-center" :options="dropOptions" @vdropzone-success="dropLogo"></vue-dropzone>
                    </div>
                </div>
            </div>
        </div>
        <deleteModal ref="deleteModal" @performConfirmAction="deleteImage"></deleteModal>
        <deleteModal ref="disableModal" @performConfirmAction="deleteStylist"></deleteModal>
    </div>
</template>
<script>
import _ from 'lodash';
import DeleteModal from './../../Delete_Modal'
import vueDropzone from "vue2-dropzone";
import {handleSessionExpired, getCityList} from '@/assets/js/dashboard/dashboard.js'
import {contactValidation, getMessage} from '@/assets/js/dashboard/utilities.js'
import Therapy from '../../salonMenu/treatment/Therapy.vue';
export default {
    name: "tukangStaffForm",
    components:{
        vueDropzone, DeleteModal
    },
    // props:{
    //     isEdit: {type: Boolean},
    // },
    data(){
        return{
            isEdit: false,
            outletID: 0,
            stylistID: 0,
            stylistName: "", contact: "", location: "", cities: [], selectedCity: {}, stylistDetails: "",
            cityList: [], gallery: [],
            staffs:[], selectedStaff: {}, staffGallery: [], selectedStaffGallery: "",
            uploadToggle: false, selectedImage: {},
            isDropzoneShow: true,
            dropOptions: {
                url: this.$api.API_IMAGE,
                addRemoveLinks: true,
                maxFiles: 1,
                paramName: 'filename',
                headers:{
                    token: this.$util.getSessionToken()
                }
            }
        }
    },
    methods:{
        getImage(img){
            return img
        },
        selectThisImage(e){
            var cbx = document.getElementsByName("galleryCbx");
            Array.prototype.forEach.call(cbx,function(el){
                el.checked = false;
            });
            e.target.checked = true;

            var img = e.target.parentElement.nextSibling
            this.selectedStaffGallery = img.src
        },
        closeModal(isError){
            if(!isError){
                if(this.uploadToggle || this.$refs.deleteModal.toggleModal){
                    this.uploadToggle = false
                    this.$refs.deleteModal.toggleModal = false
                    this.resetImage()
                }else{
                    this.isDropzoneShow = true
                    this.returnStaffList()
                }
            }
            this.$parent.$parent.$parent.isModalShow = false;
        },
        resetImage(){
            var image = this.$store.state.stateTukangStaffImage.filter(i=> i.imageID === this.selectedImage.id)
            const found = this.gallery.some(o=> o.id == this.selectedImage.id)
            if(found){
                this.gallery = this.gallery.filter(j=> j.id !== this.selectedImage.id)
            }
            this.gallery.push({
                index: parseInt(image[0].imageID.substr(image[0].imageID.length - 1)),
                id: image[0].imageID,
                src: image[0].path,
                thumbnail: image[0].path
            })
            this.gallery.sort((a,b)=> a.index - b.index);
        },
        contactValidation(){
            var err = contactValidation(this.contact);
            var form = document.getElementById('tukang_staff_form_' + this.stylistID)
            form.querySelector('#errStaff').innerHTML = err == null ? null : this.$i18n.t('message.contact_validation.phone_number', {
                'error':  this.$i18n.t(`message.contact_validation.error.${err}`)
            })
        },
        selectStaff(item){
            this.selectedStaff = item
            this.getStaffImage(item.outletID, item.staffID)
        },
        selectCity(item){
            this.selectedCity = item
        },
        returnStaffList(){
            this.resetForm()
            this.$emit('returnStaffList');
            this.$store.commit('RESET_TUKANG_IMAGE', 'staff');
        },
        editTukangStaffForm(data){
            this.isEdit = data.isEnableTukang 
            this.outletID = data.outletID
            this.staffID = data.staffID

            this.stylistName = data.TkStylistName
            this.location = data.TkStylistLocation
            this.stylistDetails = data.TkStylistDetails
            this.contact = data.TkStylistMobile
            this.gallery = data.TkStylistImage
            
            for(var i=1; i<=6; i++){
                var key = "TkStylistImage" + i;
                if(!(this.gallery.some(el => el.id === key))){
                    this.gallery.push({
                        index: i,
                        id: key,
                        src: "",
                        thumbnail: ""
                    })
                }
            }

            if(data.isEnableTukang){
                this.stylistID = data.TkStylistID;
                this.selectedCity = {cityID: parseInt(data.TkStylistCityID), city: this.getCityName(data.TkStylistCityID)}
            }else{
                this.selectedCity = this.cities[0].city[0]
            }
            this.getStaffImage(data.outletID, data.staffID)
        },
        showUploadImage(item){
            this.selectedImage = item
            this.uploadToggle = true
        },
        showDeleteStylist(){
            var title = this.$i18n.t('button_link.disable', {'item': this.$i18n.t('tukang.stylist')})
            var message = this.$i18n.t('message.confirmation.disable_tukang_stylist', {'user': this.stylistName})
            this.$refs.disableModal.showModal(title, message)
        },
        deleteStylist(){
            let $vm = this
            const url =  $vm.$api.TUKANG_SHOP + $vm.$api.TUKANG_STAFF + "/" + this.stylistID + $vm.$api.DELETE;
                
            $vm.$axios({
                method: 'post', 
                url: url,
                baseURL: $vm.$axios.defaults.baseURL, 
                headers: {token: $vm.$session.get('token')},
            })
            .then((response) => {
                if(response.status == 200){
                    $vm.deleteToggle = false;
                    var message = $vm.$i18n.t('tukang.stylist') + $vm.$i18n.t('message.success.disable')
                    $vm.$parent.$parent.$parent.setModal($vm, false, true, message);
                }
            })
            .catch((err) => {
                var error = err.response.data.error;
                if(error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();   
                }
            })
        },
        addExistingImage(){
            if(this.selectedStaffGallery == ""){
                this.$parent.$parent.$parent.setModal(this, true, true, this.$i18n.t('header.tukang_existing_source'));
            }else{
                // var data = this.setFormData()
                // data[this.selectedImage.id] = this.selectedStaffGallery
                // this.submitTukangStylist(data, false, false)

                var obj = {
                    imageID: this.selectedImage.id,
                    path: this.selectedStaffGallery
                }
                this.$store.commit('SET_TUKANG_STAFF_IMAGE', obj);
                this.$parent.$parent.$parent.setModal(this, false, true,  this.$i18n.t('message.success.upload'));
            }
        },
        dropLogo(file, response){
            if(response.path == undefined){
                this.$parent.$parent.$parent.setModal(this, true, true, this.$i18n.t('message.error.upload'));
            }else{
                this.$parent.$parent.$parent.setModal(this, false, true,  this.$i18n.t('message.success.upload'));

                var obj = {
                    imageID: this.selectedImage.id,
                    path: response.path
                }
                this.$store.commit('SET_TUKANG_STAFF_IMAGE', obj);
            }
            this.$refs.dropzone.removeFile(file)
        },
        showDeleteImage(item){
            this.selectedImage = item
            var title = this.$i18n.t('header.delete_image')
            var message = this.$i18n.t('message.confirmation.delete_image')
            this.$refs.deleteModal.showModal(title, message)
        },
        deleteImage(){
            var obj = {
                imageID: this.selectedImage.id,
                path: ""
            }
            this.$store.commit('SET_TUKANG_STAFF_IMAGE', obj);
            var data = {}
            data[this.selectedImage.id] = ""
            this.submitTukangStylist(data, false, true)
        },
        submitFormData(){
            var data = this.setFormData()
            // var stateImage = this.$store.state.stateTukangStaffImage
            var stateImage = JSON.parse(JSON.stringify(this.gallery))
            for(var i=0; i<stateImage.length; i++){
                data[stateImage[i].id] = stateImage[i].src
            }
            this.submitTukangStylist(data, true, false)
        },
        setFormData(){
            var data = {
                staffID: this.staffID,
                TkStylistName: this.stylistName,
                TkStylistDetails: this.stylistDetails,
                TkStylistMobile: this.contact,
                TkStylistLocation: this.location,
                TkStylistCityID: this.selectedCity.cityID.toString()
            }
            return data
        },
        submitTukangStylist(data, isFormData, isDeleteImage){
            let $vm = this
            const QUERY_STRING = this.isEdit ? "/" + this.stylistID + this.$api.UPDATE : ""
            const url = this.$api.TUKANG_SHOP + this.$api.TUKANG_STAFF + QUERY_STRING

            $vm.$axios({
                method: 'post', 
                url: url,
                baseURL: $vm.$axios.defaults.baseURL, 
                headers: {token: $vm.$session.get('token')},
                data: data,
            })
            .then((response) => {
                if(response.status == 200){
                    var message = isFormData ? $vm.$i18n.t('subMenu.my_salon_tukang') + $vm.$i18n.t('subMenu.salon_setting_staff') + $vm.$i18n.t('message.success.success', {'action': $vm.isEdit ? $vm.$i18n.t('message.success.action.update') : $vm.$i18n.t('message.success.action.add')}) :isDeleteImage ? $vm.$i18n.t('message.success.delete_image'): $vm.$i18n.t('message.success.upload')
                    $vm.$parent.$parent.$parent.setModal($vm, false, true, message);
                }
            })
            .catch((err) => {
                var errData = err.response.data;
                if(errData.error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();  
                }else{
                    $vm.$parent.$parent.$parent.setModal($vm, true, true, $vm.$i18n.t('message.error.system_error'))
                }
            })
        },
        async getCity(){
            this.cityList = await getCityList(this);
            var group = _.groupBy(this.cityList, 'stateID');
            for(var id in group){
                var data = {}
                data["state"] = group[id][0].state
                var cityArr = []
                for(var i=0; i<group[id].length; i++){
                    cityArr.push({
                        cityID: group[id][i].cityID,
                        city: group[id][i].city,
                    })
                }
                data["city"] = cityArr;
                this.cities.push(data)
            }
            this.selectedCity = this.cities[0].city[0]
        },
        getCityName(id){
            var city = ""
            for(var i=0; i<this.cityList .length; i++){
                if(parseInt(id) == this.cityList[i].cityID){
                    city = this.cityList[i].city
                    break
                }
            }
            return city
        },
        getStaffImage(outletID, staffID){
            let $vm = this
            let url = this.$api.OUTLET + "/" + outletID + this.$api.STAFF + "/" + staffID + this.$api.IMAGES

            $vm.$axios({
                method: 'get', 
                url: url,
                baseURL: $vm.$axios.defaults.baseURL, 
                headers: {token: $vm.$session.get('token')}
            })
            .then(function(response) {
                $vm.staffGallery = response.data.result
            })
            .catch((err) => {
                var errData = err.response.data;
                if(errData.error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();  
                }
            })
        },
        resetForm(){
            this.stylistName = this.contact = this.location = this.stylistDetails = ""
            this.selectedCity = this.cities[0].city[0]
            this.gallery = []
            for(var j=1; j<=6; j++){
                var key = "TkStylistImage" + j
                this.gallery.push({
                    index: j,
                    id: key,
                    src: "",
                    thumbnail: "",
                })
            }
        }
    },
    async mounted(){
        let $vm = this
        await $vm.getCity()
    },
}
</script>
<style scoped>
.error-validation{
    font-size: 0.6875rem;
    margin-top: 0.325rem;
    color: #fd3995;
}
.link{
    cursor: pointer;
}
.card-columns{
    column-count: 2 !important;
    column-gap: 1em;
}
.card-header{
    background: #F2F0F7;
}
.show{
    display: block;
}
.img-item{
    width: 8em;
}
.icon-stack-1x{
    top: 30%;
    left: 50%;
    font-size: .35em;
}
.modal-body{
    max-height: 75vh;
    overflow-y: auto;
}
.img-thumbnail{
    width: 15em;
}
</style>